import { render, staticRenderFns } from "./user-asset-list.vue?vue&type=template&id=71758924&scoped=true"
import script from "./user-asset-list.vue?vue&type=script&lang=js"
export * from "./user-asset-list.vue?vue&type=script&lang=js"
import style0 from "./user-asset-list.vue?vue&type=style&index=0&id=71758924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71758924",
  null
  
)

export default component.exports